import { Title, ListingCard, Card, Button, Loading } from '@/components'
import useFavourite from '@/hooks/useFavourite'
import { MapIcon } from '@heroicons/react/outline'

export const Favourites = () => {
  const { favouritesListings, addFavourite, removeFavourite, favLoaded } = useFavourite()

  return (
    <div className="px-4 sm:px-6 lg:px-8 pt-6 pb-16">
      <div className="sm:flex sm:items-center mb-6">
        <div className="sm:flex-auto">
          <Title as="h1" size="lg">
            Your Favourites
          </Title>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        {!favLoaded ? (
          <div className="mx-auto sm:px-6 lg:px-6 pb-4 text-center py-6 col-span-2">
            <Loading />
          </div>
        ) : favouritesListings.length ? (
          favouritesListings.map((favourite) => (
            <Card key={favourite.id}>
              <ListingCard listing={favourite} loggedIn={true} />
            </Card>
          ))
        ) : (
          <div className="text-center col-span-2 mt-3 ">
            <div className="border-2 dark:border-zinc-600 border-zinc-400 border-dashed px-6 py-16 max-w-3xl rounded-lg mx-auto">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="mx-auto h-12 w-12 text-brand"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                />
              </svg>
              <Title as="h3" size="lg">
                No Favourites
              </Title>

              <p className="mt-1 text-base  dark:text-zinc-200 text-zinc-600 font-medium">
                Get out there and start loving.
              </p>
              <div className="mt-6">
                <Button
                  url="/explore"
                  internal
                  withIcon={<MapIcon className="-ml-1 mr-2 h-5 w-5" aria-hidden="true" />}
                >
                  Explore
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
